import { useQuery } from '@tanstack/react-query'
import { useApiFetch } from '../../../shared/api/useApiFetch'

export interface UserSearchMembership {
  districtId: string
  role: 'SuperAdmin' | 'Admin' | 'User'
}

export interface UserSearchResult {
  id: string
  email: string
  displayName: string
  memberships: UserSearchMembership[]
}

// The term is whatever an admin types (a name or an email address), so it goes in a
// POST body: a URL is written to every log on its way, and a body is not.
export function useUserSearch(rawQuery: string) {
  const call = useApiFetch()
  const query = rawQuery.trim()
  return useQuery({
    queryKey: ['impersonation', 'user-search', query],
    queryFn: () =>
      call<UserSearchResult[]>('/api/v1/users/search', {
        method: 'POST',
        body: JSON.stringify({ search: query }),
      }),
    enabled: query.length >= 2,
    staleTime: 30_000,
  })
}
